import React, {useState, useEffect} from "react";
// import PerformanceTable from "../components/PerformanceTable";
import MainTable from "../components/MainTable";
import {PerformanceAddBox, ConfirmBox} from "../components/PerformanceAddBox";
import {useUser} from "../context/UserContext";
import PerformanceHooks from "../hooks/PerformanceHooks";


function PerformanceInvest() {
  
  const typeKeyKor = "매출";
  const typeKey = "invests";
  const mainTitle = "매출관리 리스트";
  const addBoxTitle = "투자현황";

  const {authority, company} = useUser();

  let newDataTitles = [
    { key: "_id", label: "", type: "_id", req: false, tableShow: true, searchable:false },
    { key: `${typeKey}_date`, label: "날짜", type: "date", req: true, tableShow: true },
    { key: "startup_name", label: "입주사명", type: "company", req: true, tableShow: true },
    { key: "investor", label: "투자자", type: "text", req: true, tableShow: true },
    { key: "invest_type", label: "투자 단계", type: "select", options: ["Pre-seed", "Seed", "Series A", "Series B", "Series C"], 
      req: true, tableShow: true },
    { key: "amount", label: "투자금", type: "money", req: true, tableShow: true },
    { key: "etc", label: "기타", type: "text", req: false, tableShow: true },
    { key: "file_name", label: "첨부파일", type: "file", req: false, tableShow: false, searchable:false } // 숨김 처리
  ];

  const { data, loading, setFilteredData, downloadFilteredData,
    headTitles, isModalOpen, setIsModalOpen, selectedRow, openModal, closeModal,
    handleDelete, handleSave, actionMenuItems, handleActionMenuClick, selectedData } =
    PerformanceHooks(typeKey, typeKeyKor, newDataTitles);

  const handleNewEntry = () => {
    // console.log("매출관리 신규 작성 버튼 클릭됨!");
    setIsModalOpen("new");
  };
  //신규 작성 파트 (파트별 변경 필요)
  useEffect(() => {
    const eventHandler = () => {
      console.log(`🟣 [Performance] newPerformanceEntry_performance_${typeKey} 감지됨!`);
      handleNewEntry();
    };

    window.addEventListener(`newPerformanceEntry_${typeKey}`, eventHandler);
    return () => {
      console.log("⚪ [Performance] 이벤트 리스너 제거됨");
      window.removeEventListener(`newPerformanceEntry_${typeKey}`, eventHandler);
    };
  }, []);

  const handleNewEntry2 = () => {
    downloadFilteredData();
  };
  
  //신규 작성 파트 (파트별 변경 필요)
  useEffect(() => {
    const eventHandler = () => {
      console.log(`🟣 [Performance] newPerformanceEntry_performance_${typeKey}2 감지됨!`);
      handleNewEntry2();
    };

    window.addEventListener(`newPerformanceEntry_${typeKey}2`, eventHandler);
    return () => {
      console.log("⚪ [Performance] 이벤트 리스너 제거됨");
      window.removeEventListener(`newPerformanceEntry_${typeKey}2`, eventHandler);
    };
  }, []);

  if(authority === 3 || authority === 2 || authority === 4){
    newDataTitles = newDataTitles.map(field =>
      field.label === "입주사명" ? {...field, value: company} : field
    );
  }

  const exData = [
    { id: 1, date: "2024-01-01", company: "회사 A", client: "거래처 B", clientNumber: "1234567890", item: "상품 X", amount: 1000000, etc: "https://example.com" },
    { id: 2, date: "2024-01-15", company: "회사 A", client: "거래처 C", clientNumber: "2345678901", item: "상품 Y", amount: 2000000, etc: "https://example.com" },
    { id: 3, date: "2024-02-01", company: "회사 A", client: "거래처 D", clientNumber: "3456789012", item: "상품 Z", amount: 3000000, etc: "https://example.com" },
  ];

  return (
    <div style={{flex: 1, display: 'flex', flexDirection: "column"}}>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
        <MainTable title={mainTitle} tableHeadTitles={headTitles} tableData={data}
          onActionMenuClick={handleActionMenuClick} actionMenuItems={actionMenuItems}
          pageType={'performance'} dateFilterBase={`${typeKey}_date`} setUpperData={setFilteredData} performanceType={typeKey}
          mainSearchKey="startup_name"/>
        {/* 모달 렌더링 */}
        {isModalOpen && (() => {
          switch (isModalOpen) {
            case "new":
              return <PerformanceAddBox onClose={closeModal} dataTitles={newDataTitles} onSave={handleSave}
                boxTitle={addBoxTitle}/>;
            case "edit":
              return <PerformanceAddBox onClose={closeModal} dataTitles={newDataTitles} 
                onSave={handleSave} data={selectedData}
                fixOrNot = {true} onDelete ={handleDelete} boxTitle={addBoxTitle}/>;
            case "detail":
              return <PerformanceAddBox onClose={closeModal} dataTitles={newDataTitles} onSave={handleSave}
                data={selectedData} onDelete={handleDelete} boxTitle={addBoxTitle}/>;
            case "delete":
              return (
                <ConfirmBox
                  head="정말 삭제하시겠습니까?"
                  describe="삭제된 데이터는 복구할 수 없습니다."
                  btn1Text="예"
                  btn1Main={false}
                  btn1Action={() => handleDelete(selectedRow)}
                  btn2Text="아니오"
                  btn2Action={closeModal}
                  onClose={closeModal}
                />
              );
            default:
              return null;
          }
        })()}
        </>            
      )}
    </div>
  );

}

export default PerformanceInvest;